import { fetchContacts } from "services/api/creators";
import { generateUniqueKey, getErrorMessage, isFresh } from "utils/helpers";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { AuthState } from "slices/auth/reducer";
import apiConfig from "constants/apiConfig";
import { ERROR } from "types";
import { Contact, CreatorContactsFilters, CreatorsReducerState } from "types/creators";

export const fetchContactsThunk = createAsyncThunk<
    { filterId: string; filters: CreatorContactsFilters; count: number; items: Contact[]; unprocessed: number; failed: number },
    { force?: boolean; filters: CreatorContactsFilters },
    { rejectValue: string }
>(
    'creators/fetchContacts',
    async ({ force = false, filters }, { getState, rejectWithValue }) => {
        try {
            const state = getState() as { auth: AuthState, creators: CreatorsReducerState };
            const hubId = state.auth.selectedHubId;
            if (!hubId) {
                throw new Error("Hub ID is required");
            }
            const filterId = generateUniqueKey(filters, ['page']);
            const STALE_TIME = apiConfig.FETCH_CONTACTS.staleTime;
            if(filters.page === 1 && !force && isFresh(state.creators.filtered_lists?.[filterId]?.last_fetched_at, STALE_TIME)){
                return rejectWithValue(ERROR.CACHED);
            }
            const contacts = await fetchContacts(hubId, filters);
            return {
                filterId,
                filters,
                count: contacts.count,
                items: contacts.items,
                unprocessed: contacts.unprocessed ?? 0,
                failed: contacts.failed ?? 0,
            };
        } catch (error) {
            return rejectWithValue(getErrorMessage(error, "Failed to fetch contacts"));
        }
    }
)